import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import TitleBox from "./TitleBox";

function TopNavBar({
  showBackArrow = true,
  subtitle,
  handleNav,
  logoType = "america",
}: {
  showBackArrow?: boolean;
  subtitle?: string;
  handleNav?: () => void;
  logoType?: string;
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const handleBackClick = () => {
    if (handleNav) {
      return handleNav();
    }
    navigate(-1); // Navigates back to the previous page
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderBottom: 1,
        borderColor: "#CCCCCC",
        width: "100vw",
      }}
    >
      <AppBar
        position="static"
        sx={{
          backgroundColor: "white",
          pt: 2,
          pb: 2,
          minWidth: isLargeScreen ? theme.breakpoints.values.md : "100vw",
          maxWidth: theme.breakpoints.values.md,
        }}
        elevation={0}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          {showBackArrow && (
            <IconButton
              size="large"
              edge="start"
              aria-label="back"
              onClick={handleBackClick}
              sx={{ color: "#000", position: "absolute", left: "4.5%" }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <TitleBox subtitle={subtitle} logoType={logoType} />
          </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default TopNavBar;
